<!--
 * @Author: yyl
 * @Date: 2025-06-25 10:39:40
 * @LastEditTime: 2025-07-03 15:40:57
 * @LastEditors: yyl
 * @Description: 
 * @FilePath: /bolimao/Users/bolimao/Desktop/A-类私有云的项目/下关中学/xiaguan-schools-website/src/views/ListView.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div>
    <div class="container">
      <div class="flex">
        <div style="width: 17%" v-if="!isMobile">
          <div class="card-right--title">相关栏目</div>

          <div
            class="card-right--item"
            v-for="item in sectionData.leftMenu"
            :key="item.id"
            :style="{ background: nowLocation.id === item.id ? '#D6D6D6' : '' }"
            @click="handleMenuItemClick(item)"
          >
            {{ item.title }}
          </div>
        </div>

        <div
          style="
            flex: 1;

            padding-left: 14px;
            padding-right: 4px;
          "
        >
          <div class="">
            <div style="padding: 10px" class="flex items-center">
              <i
                class="el-icon-s-home"
                style="color: #606266; font-size: 16px"
              />

              <div style="color: #606266; font-size: 14px; padding: 0 5px">
                当前位置:
              </div>

              <el-breadcrumb separator="/">
                <el-breadcrumb-item v-for="item in location" :key="item.id">{{
                  item.title
                }}</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>

          <div style="border: 1px solid #e0dcdc; border-radius: 4px">
            <div class="main-tag" style="">
              {{ nowLocation.title }}
            </div>
          </div>

          <div style="padding-top: 16px">
            <div class="item" v-for="item in listData.data" :key="item.id">
              <div class="">
                <div class="">
                  <div
                    class="list-item flex items-center"
                    @click="handleGoDetailClick(item)"
                  >
                    <div style="text-align: center">
                      <i class="el-icon-document"></i>
                    </div>
                    <div
                      class="list-item__title"
                      style="flex: 1; margin: 0 10px"
                    >
                      {{ item.title }}
                    </div>
                    <div class="" style="text-align: center">
                      {{ item.created_at }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="listData.data && listData.data.length === 0"
              style="text-align: center; color: #666; padding: 20px"
            >
              暂无数据
            </div>
          </div>

          <div style="text-align: center; padding: 10px">
            <el-pagination
              background
              hide-on-single-page
              layout="total, prev, pager, next, jumper"
              :total="listData.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchListData } from "@/api/home"
import resizeMixin from "@/mixins/resize"

export default {
  name: "ListView",

  mixins: [resizeMixin],

  data() {
    return {
      title: "",
      section_id: "",
      sectionData: {
        location: [],
      },
      location: [],
      nowLocation: {},
      page: 1,
      page_size: 10,
      listData: {},
    }
  },

  watch: {
    $route(to, from) {
      // 如果 section_id 或 title 变化，重新请求数据
      if (
        to.query.section_id != from.query.section_id ||
        to.query.title != from.query.title
      ) {
        this.title = this.$route.query.title
        this.section_id = this.$route.query.section_id
        this.getListData()
      }
    },
  },

  created() {
    this.title = this.$route.query.title

    this.section_id = this.$route.query.section_id
    this.getListData()
  },

  methods: {
    async getListData() {
      try {
        const res = await fetchListData({
          section_id: this.section_id,
          page: this.page,
          page_size: this.page_size,
        })
        this.sectionData = res
        this.location = res.location || []
        this.nowLocation = this.location[this.location.length - 1] || {}
        this.listData = res.list || {}

        // this.handleGoDetailClick(this.listData.data[0])
      } catch (err) {
        console.error("加载失败", err)
      }
    },

    handleGoDetailClick(item) {
      console.log(item)
      this.$router.push(`/article?id=${item.id}`)
    },

    safePush(path, query) {
      if (
        this.$route.path != path ||
        JSON.stringify(this.$route.query) != JSON.stringify(query)
      ) {
        this.$router.push({ path, query })
      }
    },

    handleMenuItemClick(item) {
      console.log(`handleMenuItemClick`, item)

      // Article = 1,
      // List = 2,
      // Image_Text = 3,
      // Image = 4,
      // Link = 5,

      if (item === 0) {
        this.$router.push("/")
      }

      if ([5].includes(item.content_model_id)) {
        window.open(item.url, "_blank")
      } else if ([4].includes(item.content_model_id)) {
        this.safePush(`/teachers`, {
          section_id: String(item.id),
          title: item.title,
        })
      } else if ([2].includes(item.content_model_id)) {
        this.safePush("/list", {
          section_id: String(item.id),
          title: item.title,
        })
      } else if ([3].includes(item.content_model_id)) {
        this.safePush("/list-image", {
          section_id: String(item.id),
          title: item.title,
        })
      } else if ([1].includes(item.content_model_id)) {
        this.safePush(`/article`, {
          content_model_id: item.content_model_id,
          id: String(item.id),
        })
      }

      this.drawerVisible = false
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.page = val
      this.getListData()
    },

    onResize() {
      this.isMobile = window.innerWidth < 768 // 当窗口宽度小于 768px 时，认为是移动端
    },
  },
}
</script>

<style scoped lang="scss">
.card-right--title {
  height: 74px;
  line-height: 74px;
  color: #fff;
  text-align: center;
  // background-color: #005db3;
  background-color: #1c3a97;
}
.box-card {
  padding: 10px;
  background-color: #fff;
  margin: 16px 0;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(235, 238, 245);
}

.card-right--item {
  text-align: center;
  line-height: 32px;
  padding: 6px 10px;

  border: 1px solid #e0dcdc;
  border-top: none;
  cursor: pointer;

  &:hover {
    background-color: #d6d6d6;
  }
}

.main-tag {
  display: inline-block;
  padding: 5px 24px;
  background-color: #1c3a97;
  color: #fff;
  position: relative;
  &::before {
    content: "";
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #003665;
    position: absolute;
    bottom: -8px;
    right: 50%;
    margin-right: -8px;
  }
}

.list-item {
  font-size: 14px;
  padding: 8px 0px;

  cursor: pointer;

  &__title {
    &:hover {
      color: #15458b;
      text-decoration: underline;
    }
  }
}

.item {
  border-bottom: 1px solid #e0dcdc;
}

.title-link {
  &:hover {
    color: #15458b;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
